/* tslint:disable */
/* eslint-disable */
/**
 * Ameta Availability API
 * A rest api for managing the ameta availability system
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    SectionCounterDataSections,
    SectionCounterDataSectionsFromJSON,
    SectionCounterDataSectionsFromJSONTyped,
    SectionCounterDataSectionsToJSON,
} from './';

/**
 * 
 * @export
 * @interface SectionCounterDataMonths
 */
export interface SectionCounterDataMonths {
    /**
     * 
     * @type {{ [key: string]: SectionCounterDataSections; }}
     * @memberof SectionCounterDataMonths
     */
    sections: { [key: string]: SectionCounterDataSections; };
    /**
     * 
     * @type {string}
     * @memberof SectionCounterDataMonths
     */
    availability: string;
}

export function SectionCounterDataMonthsFromJSON(json: any): SectionCounterDataMonths {
    return SectionCounterDataMonthsFromJSONTyped(json, false);
}

export function SectionCounterDataMonthsFromJSONTyped(json: any, ignoreDiscriminator: boolean): SectionCounterDataMonths {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'sections': (mapValues(json['sections'], SectionCounterDataSectionsFromJSON)),
        'availability': json['availability'],
    };
}

export function SectionCounterDataMonthsToJSON(value?: SectionCounterDataMonths | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'sections': (mapValues(value.sections, SectionCounterDataSectionsToJSON)),
        'availability': value.availability,
    };
}


